import {
  React,
  Component,
  Redirect,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import CircularProgress from 'material-ui/CircularProgress';

import {LoadingDialog} from 'imports/DesignImports';
import {CompanyView} from 'imports/ViewsImports';

import {
  WelcomeVideo,
  Stages,
} from 'imports/ComponentsImports';

class HomeView extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: props.cookies.get('user'),
      token: props.cookies.get('token'),
      currentStage: props.cookies.get('current_stage'),
      loadingDialog: false,
      loading: true,
      error: false,
    }
  }

  componentDidMount(){
    if(this.state.user.position === 'Gerente Innovación')
      this.getStage()
  }

  render() {
    let user = this.state.user;
    let currentStage = this.state.currentStage;
    if(user.position === 'Innspiral'){
      return <Redirect to='/innspiral_home'/>;
    }
    if (user.position === 'Líder de proyecto' || user.position === 'Gerente de área' || user.position === 'Control de gestión') {
       return <Redirect to='/portfolio'/>;
    }
    if (user.position === 'Admin') {
       return <Redirect to='/utilities'/>;
    }
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    if(currentStage.stage.name === 'PV'){
      return(
        <div>
        <WelcomeVideo
          close={this.updateStageData}
          user={user}
          />
          {this.state.loadingDialog ? <LoadingDialog message='Espera un momento por favor' /> : null}
        </div>
      );
    }
    if(currentStage.stage.name === 'CG'){
      return(
        <div>
        <CompanyView
          />
          {this.state.loadingDialog ? <LoadingDialog message='Espera un momento por favor' /> : null}
        </div>
      );
    }
    return (
      <div>
      <Stages
        currentStage={currentStage.stage}
        user={user}
        history={this.props.history}
        />
        {this.state.loadingDialog ? <LoadingDialog message='Espera un momento por favor' /> : null}
      </div>
    );
  }

  getStage = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.getCurrentStage(this.state.user.company_id))
    .then((response) => {
      this.props.cookies.set('current_stage', JSON.stringify(response.data[response.data.length - 1]), { path: '/' });
      this.setState({
        loading: false,
        error: false,
        currentStage: response.data[response.data.length - 1],
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loading:false,
        error: true,
      });
    });
  }

  updateStageData = (stageName) => {
    this.setState({loadingDialog: true});
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.patch(routes.nextStage(this.state.user.company_id))
    .then((response) => {
      this.props.cookies.set('current_stage', JSON.stringify(response.data), { path: '/' });
      this.setState({
        currentStage: response.data,
        loadingDialog: false,
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loadingDialog: false,
      });
    });
  }
}

export default withCookies(withRouter(HomeView));



// WEBPACK FOOTER //
// ./src/views/common/HomeView.js